import * as React from 'react';

import {DebugPageHeader} from './debug-page-header';

import styles from './debug-page.module.css';

declare const NutClientConfig: {
    isInternalLogin: boolean;
};

type Props = {
    title: string;
    subtitle: string;
    children: React.ReactNode;
    onRefresh?: () => void;
    isLoading?: boolean;
    error?: string | null;
    toolbar?: React.ReactNode;
};

export function DebugPage(props: Props): React.ReactElement {
    const {title, subtitle, children, onRefresh, isLoading, error, toolbar} = props;

    if (!NutClientConfig.isInternalLogin) {
        return (
            <div className={styles.container}>
                <div className={styles.error}>This page is only available for internal users.</div>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className={styles.container}>
                <div className={styles.loading}>Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.container}>
                <div className={styles.error}>Error: {error}</div>
            </div>
        );
    }

    return (
        <>
            <DebugPageHeader title={title} subtitle={subtitle} />
            <div className={styles.container}>
                {(onRefresh || toolbar) && (
                    <div className={styles.toolbar}>
                        <div className={styles['toolbar-left']}>{toolbar}</div>
                        <div className={styles['toolbar-right']}>
                            {onRefresh && (
                                <button onClick={onRefresh} className={styles['refresh-button']}>
                                    Refresh
                                </button>
                            )}
                        </div>
                    </div>
                )}
                {children}
            </div>
        </>
    );
}
